/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents a country object.
 */
export interface CountryModel { 
    /**
     * Lower case of the ISO 3166-1 A-2 country code.
     */
    code: string;
    /**
     * Determines if the country is supported.
     */
    isSupported: boolean;
    /**
     * Country name.
     */
    name: string;
}

